import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import { Card } from 'react-native-elements';

type WordPair = {
  id: number;
  word: string;
  definition: string;
  isFlipped: boolean;
  isMatched: boolean;
};

const wordPairs = [
  { word: "Happy", definition: "Feeling joy or pleasure" },
  { word: "Big", definition: "Large in size" },
  { word: "Fast", definition: "Moving quickly" },
  { word: "Soft", definition: "Pleasant to touch" },
  { word: "Loud", definition: "Making much noise" },
  { word: "New", definition: "Recently made" },
];

export default function VocabularyMaster() {
  const [cards, setCards] = useState<WordPair[]>([]);
  const [selectedCard, setSelectedCard] = useState<number | null>(null);
  const [score, setScore] = useState(0);
  const [moves, setMoves] = useState(0);

  useEffect(() => {
    initializeGame();
  }, []);

  const initializeGame = () => {
    const gameCards: WordPair[] = [];
    wordPairs.forEach((pair, index) => {
      gameCards.push(
        { id: index * 2, word: pair.word, definition: pair.definition, isFlipped: false, isMatched: false },
        { id: index * 2 + 1, word: pair.word, definition: pair.definition, isFlipped: false, isMatched: false }
      );
    });
    setCards(gameCards.sort(() => Math.random() - 0.5));
  };

  const handleCardPress = (index: number) => {
    if (cards[index].isMatched || cards[index].isFlipped) return;

    const newCards = [...cards];
    newCards[index].isFlipped = true;
    setCards(newCards);

    if (selectedCard === null) {
      setSelectedCard(index);
    } else {
      setMoves(moves + 1);
      checkMatch(selectedCard, index);
    }
  };

  const checkMatch = (firstIndex: number, secondIndex: number) => {
    if (cards[firstIndex].word === cards[secondIndex].word) {
      const newCards = [...cards];
      newCards[firstIndex].isMatched = true;
      newCards[secondIndex].isMatched = true;
      setCards(newCards);
      setScore(score + 100);
      setSelectedCard(null);
    } else {
      setTimeout(() => {
        const newCards = [...cards];
        newCards[firstIndex].isFlipped = false;
        newCards[secondIndex].isFlipped = false;
        setCards(newCards);
        setSelectedCard(null);
      }, 1000);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.score}>Score: {score}</Text>
        <Text style={styles.moves}>Moves: {moves}</Text>
      </View>

      <View style={styles.grid}>
        {cards.map((card, index) => (
          <TouchableOpacity
            key={card.id}
            style={styles.cardContainer}
            onPress={() => handleCardPress(index)}
          >
            <Card containerStyle={[
              styles.card,
              card.isFlipped && styles.cardFlipped,
              card.isMatched && styles.cardMatched
            ]}>
              <Text style={styles.cardText}>
                {card.isFlipped || card.isMatched ? card.word : '?'}
              </Text>
            </Card>
          </TouchableOpacity>
        ))}
      </View>

      <TouchableOpacity style={styles.resetButton} onPress={initializeGame}>
        <Text style={styles.resetButtonText}>Reset Game</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
    backgroundColor: '#f5f5f5',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 15,
  },
  score: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#4CAF50',
  },
  moves: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FF9800',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardContainer: {
    width: Dimensions.get('window').width / 2 - 20,
    aspectRatio: 1,
    padding: 5,
  },
  card: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 10,
    margin: 0,
  },
  cardFlipped: {
    backgroundColor: '#e3f2fd',
  },
  cardMatched: {
    backgroundColor: '#c8e6c9',
  },
  cardText: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  resetButton: {
    backgroundColor: '#4CAF50',
    padding: 15,
    borderRadius: 25,
    margin: 20,
    alignItems: 'center',
  },
  resetButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
}); 